module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p2222"
  }, [_c('div', {
    staticClass: "p1111"
  }, [_c('btn', {
    attrs: {
      "size": "lg",
      "theme": "primary-blank",
      "block": "true",
      "name": "普通操作"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p1111"
  }, [_c('btn', {
    attrs: {
      "size": "lg",
      "theme": "primary",
      "block": "true",
      "name": "普通操作2"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p1111"
  }, [_c('btn', {
    attrs: {
      "size": "lg",
      "theme": "warm",
      "block": "true",
      "name": "警告操作",
      "icon": "safe"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p1111"
  }, [_c('btn', {
    attrs: {
      "size": "lg",
      "theme": "warm-blank",
      "block": "true",
      "name": "警告操作2",
      "icon": "safe"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p1111"
  }, [_c('btn', {
    attrs: {
      "theme": "primary",
      "name": "按 钮"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p1111"
  }, [_c('btn', {
    attrs: {
      "size": "sm",
      "theme": "primary",
      "name": "按 钮"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1ca16d60!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/btn/demo.vue
// module id = 231
// module chunks = 24